import ErrorBoundary from "app/ErrorBoundary/ErrorBoundary";
import React from "react";
import "./MainEventsLayoutDesktop.scss";
import "./MainEventsLayoutTablet.scss";

const MainHelpAndLearningLayoutDesktop = (
  WrappedComponent: React.ComponentType<any>
): React.FC<any> => {
  const MainEventsLayoutDesktop: React.FC<any> = props => {
    return (
      <div className="events-screen help-and-learning-screen">
        <div className="events-screen__wrapper">
          <div className="events-screen__col events-screen__col-8">
            <ErrorBoundary>
              <WrappedComponent {...props} />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    );
  };

  return MainEventsLayoutDesktop;
};

export default MainHelpAndLearningLayoutDesktop;
